import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-action-detail',
  templateUrl: './action-detail.component.html',
  styleUrls: ['./action-detail.component.scss'],
})
export class ActionDetailComponent {
  actionData!: string;
  isJsonData: boolean = false;
  formattedJsonData?: any;
  title: string = 'Detalle de Acción';

  constructor(private modalController: ModalController) { }

  ngOnInit() {
    this.processActionData();
  }

  processActionData() {
    try {
      // Intentar parsear como JSON
      this.formattedJsonData = JSON.parse(this.actionData);
      this.isJsonData = true;
    } catch (error) {
      // No es JSON válido
      this.isJsonData = false;
    }
  }

  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  formatValue(value: any): string {
    if (typeof value === 'object' && value !== null) {
      return JSON.stringify(value, null, 2);
    }
    return String(value);
  }

  isObject(value: any): boolean {
    return typeof value === 'object' && value !== null;
  }

  async close() {
    await this.modalController.dismiss();
  }
}
